<div class="container p-5">
  <div class="row mb-5">
    <div class="col-md-12">
      <h2 class="mat-heading-large" i18n>Embed</h2>
    </div>
  </div>
  <div class="row my-5">
    <div class="col-md-6">
      <h3 class="mat-title-large" i18n>Embed Type</h3>
      <mat-chip-listbox class="pb-3">
        @for(embedType of embedTypes; track embedType) {
        <mat-chip-option
          value="{{ embedType }}"
          [selected]="tab() == embedType"
          (selectionChange)="tab.set($event.source.value ?? defaultEmbedType)"
          >{{ embedTypeName[embedType] }}</mat-chip-option
        >
        }
      </mat-chip-listbox>

      @if(tab() == "event") {
      <mat-form-field class="w-100 mb-3" appearance="outline">
        <mat-label i18n>Event</mat-label>
        <input matInput [value]="'Swiss Jam 25'" [disabled]="true" />
      </mat-form-field>
      }

      <h3 class="mat-title-large" i18n>Embedding Preferences</h3>
      <div class="p-3">
        <!-- General settings -->
        <mat-form-field class="w-100 mb-3" appearance="outline">
          <mat-label i18n>Language</mat-label>
          <mat-select [(ngModel)]="embedLanguage">
            <mat-option value="auto">Automatic</mat-option>
            @for(code of supportedLanguageCodes; track code) {
            <mat-option [value]="code"
              >{{ languages[code].name_native }} ({{ code }})</mat-option
            >
            }
          </mat-select>
        </mat-form-field>

        @switch (tab()) { @case ("map") {
        <mat-slide-toggle [(ngModel)]="showSatelliteToggle" i18n
          >Show satellite toggle</mat-slide-toggle
        >
        <mat-slide-toggle [(ngModel)]="showGeolocation" i18n
          >Show geolocation</mat-slide-toggle
        >
        } @case ("event") {
        <mat-slide-toggle [(ngModel)]="showEventHeader" i18n
          >Show Event header</mat-slide-toggle
        >
        } }
      </div>
    </div>
    <div class="col-md-6">
      <iframe
        class="bg-black shadow-lg border w-100 overflow-hidden d-block"
        [src]="safeIframeUrl()"
        height="600px"
      ></iframe>
    </div>
  </div>
  <div class="row my-5">
    <div class="col-md-12">
      <h3 class="mat-title-large" i18n>HTML Embed Code</h3>
      <app-code-block [code]="iframeCode()"></app-code-block>
    </div>
  </div>
</div>
